import { useSelector } from 'react-redux';
import EditIconButton from '@/components/UI/Button/EditIconButton';
import type { RootState } from '../../../store';

interface IFormReviewProps {
  updateStep: (i: number) => void;
}

export default function FormReview({ updateStep }: IFormReviewProps) {
  const opportunity = useSelector((state: RootState) => state.opportunity);

  const { opportunityInfo, preliminaryProgram, projectUses, projectSource, mileStoneSchedule, projectTeam, vendor, incentive } =
    opportunity;

  const setStep = (i: number) => {
    window.scrollTo(0, 0);
    updateStep(i);
  };

  return (
    <div className=''>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Basic Project Information</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(0)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Project Name</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.projectName}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Address</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.address}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Market</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.market}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Sub-Market</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.subMarket}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Project Type</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.projectType}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Construction Type</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.constructionType}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Procurement Type</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.constructionType}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Sourcing Document</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.sourcingDocument}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Development Partner</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.developmentPartner}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Square Feet</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{opportunityInfo.squareFeet} Sq.Ft</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Project Uses</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(2)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Acquisition</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.acquisition}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Construction Cost</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.constructionCost}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Soft Cost</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.softCost}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Financing Cost</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.financeCost}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Development Cost</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.developmentCost}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Soft Cost</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectUses.softCost}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Project Sources</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(3)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Debt</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectSource.debt}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Equity</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectSource.equity}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Other</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>${projectSource.other}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Milestone Schedule</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(4)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Site Control</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.siteControl}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Design and Entitlements</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.designAndEntitlements}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Acquisition</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.acquisition}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Financial Close</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.financialClose}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Construction</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.construction}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Project Completion</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{mileStoneSchedule.projectCompletion}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Project Team</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(5)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Project Executive</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.projectExecutive}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Development Manager</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.developmentManager}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Development Associate</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.developmentAssociates}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Investment Associate</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.investmentAssociates}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Construction Manager</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.constructionManager}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>QA/QC</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{projectTeam.qcqa}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Vendor</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(6)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Architect</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{vendor.architect}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Civil Engineer</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{vendor.civilEngineer}</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Structural Engineer</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{vendor.structuralEngineer}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>General Contractor</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{vendor.generalContractor}</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Other</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>{vendor.other}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div className='bg-white shadow overflow-hidden sm:rounded-lg mb-12'>
        <div className='border-l-4 border-primaryColor-normal px-4 py-5 sm:px-6 flex items-center justify-between'>
          <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Incentives</h3>
          <EditIconButton size='h-10 w-10' onClick={() => setStep(7)} />
        </div>
        <div className='border-t border-gray-200'>
          <dl>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Opportunity Zone</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'></dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>State Historic Tax Credits</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>file</dd>
            </div>
            <div className='bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>Federal Historic Tax Credits </dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>file</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>New Market Tax Credits*</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>file</dd>
            </div>
            <div className='bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6'>
              <dt className='text-sm font-medium text-gray-500'>QCT or DDA</dt>
              <dd className='mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2'>file</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
